import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { ASSIGN_OPTIONS } from '../_constants/assignConstants'
import { useCloneForm, useCloneFormActions } from '../_form/CloneServiceOrderForm'
import TagPicker from '../../../../components/form/TagPicker'

const AssignPicker = () => {
  const { setAssign } = useCloneFormActions()
  const form = useCloneForm()

  const canSeeOnlySelfSOs = useSessionPermission('seeOnlySelfServiceOrders')
  if (canSeeOnlySelfSOs) return false

  return <TagPicker options={ASSIGN_OPTIONS} onChange={setAssign} value={form.assign} useMarker />
}

export default AssignPicker
